export default class bundle {
    static loadView(view: string) {
        return () => import(/* webpackChunkName: "views/[request]" */ `@/views/${view}.vue`);
    }
}
